import Riot from 'riot';
import $ from 'jquery';
import { ActionTypes } from '../constants/ActionTypes';
import { Dispatcher } from '../dispatcher/Dispatcher';

const CHANGE_EVENT = 'update';

// State
const _cohorts = {};

// Event emitter
const _observable = {};
Riot.observable(_observable);

// Helper functions to manipulate data
const _addCohort = (cohort) => {
  if (_cohorts[cohort.path] === undefined) {
    _cohorts[cohort.path] = {};
  }
  $.extend(true, _cohorts[cohort.path], cohort);
};

// Interface to view-controllers
export const CohortStore = {
  dispatchToken: null,

  registerChangeCallback: (callback) => {
    _observable.on(CHANGE_EVENT, callback);
  },

  unregisterChangeCallback: (callback) => {
    _observable.off(CHANGE_EVENT, callback);
  },

  getCohort: (cohortPath) => {
    if (_cohorts[cohortPath]) {
      const result = {};
      $.extend(true, result, _cohorts[cohortPath]);
      return result;
    } else {
      return null;
    }
  },
};

// Responses to actions from dispatcher
CohortStore.dispatchToken = Dispatcher.register((action) => {
  if (action.type === ActionTypes.COHORT_UPDATE) {
    _addCohort(action.cohort);
    _observable.trigger(CHANGE_EVENT);
  }
});
